# Generated by https://pagedraw.io/pages/11538
React = require 'react'
Listitem = require './componentlistitem'


render = ->
    React.createElement("div", {"className": "componentlist-componentlist-8"},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            .componentlist-componentlist-8 {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
            }
            
            .componentlist-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .componentlist-0-0 {
                flex-grow: 1;
                flex-basis: 0px;
                display: flex;
                flex-direction: column;
                margin-top: -10px;
            }
            
            .componentlist-rectangle_5 {
                display: flex;
                flex-direction: column;
                min-height: fit-content;
                background: rgba(255, 255, 255, 0);
                margin-top: 10px;
                flex-grow: 1;
            }
            
            .componentlist-0-0-0-0-0 {
                display: flex;
                flex-shrink: 0;
            }
            
            .componentlist-componentlistitem_instance-7 {
                flex-grow: 1;
                flex-basis: 0px;
                display: flex;
                flex-direction: column;
            }
            
            * {
                box-sizing: border-box;
            }
            
            body {
                margin: 0;
            }
            
            button:hover {
                cursor: pointer;
            }
            
            a {
                text-decoration: none;
                color: inherit;
            }
            
            .pd-onhover-parent >.pd-onhover {
                display: none;
            }
            
            .pd-onhover-parent:hover > * {
                display: none;
            }
            
            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }
            
            .pd-onactive-parent > .pd-onactive {
                display: none;
            }
            
            .pd-onactive-parent:active > * {
                display: none;
            }
            
            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }
            
            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),  
        React.createElement("div", {"className": "componentlist-0"},
            React.createElement("div", {"className": "componentlist-0-0"},
                ( this.props.components.map (component, i) =>
                    React.createElement("div", {"key": (i), "className": "componentlist-rectangle_5"},
                        React.createElement("div", {"className": "componentlist-0-0-0-0-0"},
                            React.createElement("div", {"className": "componentlist-componentlistitem_instance-7"},
                                React.createElement(Listitem, {"active": (component.active), "title": (component.title)}) 
                            )
                        )
                    )
                )
            )
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/store/componentlist.cjsx